import Vue from 'vue';
import Vuex from 'vuex';
import * as Sentry from '@sentry/browser'
import IResource from "@/interfaces/IResource";
import axios from 'axios';

Vue.use(Vuex);

let initialState: any = {
	loggedin: false,
	noorg: false,
	user: null,
	resources: [],
	users: [],
	resourcesLoading: false,
	organisation: null,
	subscription: null,
	activeplan: null,
	plans: null
}

const state: any = Object.assign({}, initialState)

export default new Vuex.Store({
	state,
	mutations: {
		RESET_STATE(state, empty) {
			for (let f in state) {
				Vue.set(state, f, initialState[f])
			}
		},
		SET_LOGGEDIN(state, loggedin) {
			state.loggedin = loggedin
		},
		SET_USER(state, user) {
			state.user = user;
			if (user !== null) {
				Sentry.configureScope((scope) => {
					scope.setUser({
						'id': user.id + '',
						'email': user.email
					});
				});
			}
		},
		SET_RESOURCES(state, resources) {
			state.resources = resources;
		},
		SET_RESOURCESLOADING(state, isLoading) {
			state.resourcesLoading = isLoading;
		},
		SET_ORGANISATION(state, organisation) {
			state.noorg = !organisation;
			state.organisation = organisation;
		},
		SET_USERS(state, users) {
			state.users = users;
		},
		SET_SUBSCRIPTION(state, subscription) {
			state.subscription = subscription;
		},
		SET_ACTIVEPLAN(state, plan) {
			state.activeplan = plan;
		},
		SET_PLANS(state, plans) {
			state.plans = plans;
		},
	},
	actions: {
		async loadResources ({ commit, state }, id) {
			if(!state.resourcesLoading) {
				commit('SET_RESOURCESLOADING', true);
				const response = await Vue.prototype.$http.get('/private/resource');
				commit('SET_RESOURCESLOADING', false);
				if (response.status !== 200) {
					throw new Error('no resource found');
				}
				commit('SET_RESOURCES', response.data);
			}
		},
		async saveResource({ commit, state, dispatch }, payload) {
			let formData = new FormData();
			formData.append('name', payload.name);
			if (payload.type != null ) { formData.append('type', payload.type) }
			if (payload.description != null ) { formData.append('description', payload.description) }
			if (payload.starttime != null ) { formData.append('starttime', String(payload.starttime)) }
			if (payload.endtime != null ) { formData.append('endtime', String(payload.endtime)) }
			if (payload.slot_size != null ) { formData.append('slot_size', String(payload.slot_size)) }
			if (payload.auto_confirm != null ) { formData.append('auto_confirm', String(payload.auto_confirm)) }
			if (payload.confirmation_email_text) { formData.append('confirmation_email_text', String(payload.confirmation_email_text)) }
			if (payload.cancel_email_text) { formData.append('cancel_email_text', String(payload.cancel_email_text)) }
			if (payload.reservation_email_text) { formData.append('reservation_email_text', String(payload.reservation_email_text)) }
			if (payload.change_reservation_email_text) { formData.append('change_reservation_email_text', String(payload.change_reservation_email_text)) }
			if (payload.reservation_customer_editable) { formData.append('reservation_customer_editable', String(payload.reservation_customer_editable)) }
			if (payload.notification_email) { formData.append('notification_email', String(payload.notification_email)) }
			formData.append('auto_confirm', payload.auto_confirm.toString());

			await Vue.prototype.$http.post(
				`/private/resource/${payload.id}`,
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			);
			dispatch('loadResources', {root: true});
		},
		async loadOrganisation ({ commit, state }, id) {
			try {
				const response = await Vue.prototype.$http.get('/private/organisation');
				commit('SET_ORGANISATION', response.data);
				const activePlan = response.data.plan;
				const activePlanResponse = await Vue.prototype.$http.get('/private/plan/' + activePlan);
				commit('SET_ACTIVEPLAN', activePlanResponse.data);
			} catch (error) {
				if (axios.isAxiosError(error) && error && error.response && error.response.status === 404) {
					commit('SET_ORGANISATION', null);
				} else {
					throw error;
				}
			}
		},
		async loadUsers ({ commit, state }, id) {
			const response = await Vue.prototype.$http.get('/private/user');
			if (response.status !== 200) {
				throw new Error('error loading users');
			}
			commit('SET_USERS', response.data);
		},
		async loadSubscription ({ commit, state }) {
			const response = await Vue.prototype.$http.get('/private/subscription');
			if (response.status !== 200) {
				throw new Error('error loading subscription');
			}
			commit('SET_SUBSCRIPTION', response.data);
		},
		async loadPlans ({ commit, state }) {
			const response = await Vue.prototype.$http.get('/private/plan');
			if (response.status !== 200) {
				throw new Error('error loading plan');
			}
			commit('SET_PLANS', response.data);
		},
		async loadCurrentuser ({ commit, state }) {
			const response = await Vue.prototype.$http.get('/private/currentuser');
			if (response.status !== 200) {
				throw new Error('error loading currentuser');
			}
			commit('SET_USER', response.data);
		},
	},
	getters: {
		singledayResources: (state): IResource[] => {
			return state.resources.filter((resource: IResource) => resource.type === 'singleday');
		},
		multidayResources: (state): IResource[] => {
			return state.resources.filter((resource: IResource) => resource.type === 'multiday');
		}
	},
});
